import { Navigate, useLocation } from "react-router-dom";
import { server } from "../../globalSettings";

export const requestOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json' },
        };
        return requestOptions
    }

}

export const requestAuthOption = (method, data) => {
    if (data) {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
            body: JSON.stringify(data)
        };
        return requestOptions
    } else {
        const requestOptions = {
            method: method,
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`, },
        };
        return requestOptions
    }

}

// api
export const forgotPWapi = async (user) => {
    const request = requestOption("POST", user)
    try {
        const response = await fetch(`${server}forgot-password`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        localStorage.setItem("resetEmail", user.email);
                        resolve(data.data);
                    } else {
                        if (data.code === "invalid_field") {
                            reject(data?.errors?.email?.[0]);
                        }
                        else {
                            reject(data?.data?.message);
                        }
                    }
                } else {
                    reject(data.code);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(error);
                // throw error;
            })
        })

    }
};

export const updatePWApi = async (user) => {
    const request = requestAuthOption("POST", user)
    try {
        const response = await fetch(`${server}reset-password`, request);
        const data = await response.json();
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                if (response.ok) {
                    if (data.code === "success") {
                        localStorage.removeItem("resetEmail");
                        resolve(data);
                    } else if (data?.errors) {
                        reject(data?.errors);
                    } else {
                        reject(data);
                    }
                } else {
                    reject(data?.message);
                }
            });
        });
    } catch (error) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                reject(error);
                // throw error;
            })
        })

    }
};
